<script setup lang="ts">
// 닫기 경로 3가지: 닫기 버튼 / 배경 클릭 / ESC
const props = defineProps<{
  modelValue: boolean
  title?: string
}>()
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()

function close() {
  emit('update:modelValue', false)
}

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape')
    close()
}

watch(() => props.modelValue, (open) => {
  if (open)
    window.addEventListener('keydown', onKeydown)
  else
    window.removeEventListener('keydown', onKeydown)
})

onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown))
</script>

<template>
  <Teleport to="body">
    <div v-if="modelValue" class="sheet-backdrop" @click.self="close">
      <div class="sheet" role="dialog" aria-modal="true" :aria-label="title">
        <div class="sheet-head">
          <span class="sheet-title">{{ title }}</span>
          <button type="button" class="sheet-close" aria-label="닫기" @click="close">
            닫기
          </button>
        </div>
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.4);
}
.sheet {
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  background: var(--bg-card);
  border-radius: var(--radius-sheet);
  box-shadow: var(--shadow-overlay);
  padding: 20px 20px calc(20px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}
.sheet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.sheet-title {
  font-size: var(--fs-section-title);
  font-weight: 800;
  color: var(--ink);
}
.sheet-close {
  min-height: 44px;
  min-width: 44px;
  padding: 0 8px;
  border: 0;
  background: transparent;
  color: var(--ink-sub);
  font: 600 13px/1 var(--font-sans);
  cursor: pointer;
}
</style>
